import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { ApiGetAllComidas } from "../../../api/comidas";
import { ItemComida } from "./components/ItemComida";
import {
  ApiCreateComidaDetalle,
  ApiDeleteComidaDetalle,
  ApiEditComidaDetalle,
} from "../../../api/comidaDetalle";
import { dateLocal, dateToText } from "../../../utils/date";
import { TIPO_COMIDA, TIPO_COMIDA_LABEL } from "../../../utils/constanst";

const MenuComida = () => {
  const today = dateLocal().split("T")[0];
  const [fecha, setFecha] = useState(today);
  const tipoTabsInit = {
    PLATO1: {
      pre_detalle_comida_id: "",
      selected: false,
      menu: "",
      tipo: "PLATO1",
      isCreate: true,
      cal: "",
    },
    PLATO2: {
      pre_detalle_comida_id: "",
      selected: false,
      menu: "",
      tipo: "PLATO2",
      isCreate: true,
      cal: "",
    },
    SOPA: {
      pre_detalle_comida_id: "",
      selected: false,
      menu: "",
      tipo: "SOPA",
      isCreate: true,
      cal: "",
    },
    POSTRE: {
      pre_detalle_comida_id: "",
      selected: false,
      menu: "",
      tipo: "POSTRE",
      isCreate: true,
      cal: "",
    },
    DIETA: {
      pre_detalle_comida_id: "",
      selected: false,
      menu: "",
      tipo: "DIETA",
      isCreate: true,
      cal: "",
    },
    ALERGENOS: {
      pre_detalle_comida_id: "",
      selected: false,
      menu: "",
      tipo: "ALERGENOS",
      isCreate: true,
      cal: "",
    },
  };

  const [tiposTabs, setTiposTabs] = useState(tipoTabsInit);

  const [comidas, setComidas] = useState([]);
  const [comidaSelected, setComidaSelected] = useState(null);
  const [loading, setLoading] = useState(false);

  const init = async () => {
    setLoading(true);
    const res = await ApiGetAllComidas();
    if (res.sms === "err") {
      toast.error(res.mensaje);
      return;
    }
    setComidas(res.data);
    setLoading(false);
  };

  const handleSubmit = async ({ state }) => {
    console.error("handleSubmit :::", state);

    //e.preventDefault();
    setLoading(true);
    if (comidaSelected?.pre_comida_id === "") {
      toast.error("Seleccione una comida");
      setLoading(false);
      return;
    }

    if (state.menu === "") {
      toast.error(
        `el nombre del/la ${TIPO_COMIDA_LABEL[state.tipo]} es obligatorio`
      );
      setLoading(false);
      return;
    }

    if (fecha === "" || fecha === null) {
      toast.error("Seleccione una fecha");
      setLoading(false);
      return;
    }

 

    let res = state.isCreate
      ? await ApiCreateComidaDetalle({
          nombre: state.menu,
          pre_comida_id: comidaSelected?.pre_comida_id,
          fecha_menu: fecha,
          tipo: state.tipo,
          cal: state.cal ? state.cal : "",
        })
      : await ApiEditComidaDetalle({
          nombre: state.menu,
          pre_detalle_comida_id: state.pre_detalle_comida_id,
          fecha_menu: fecha,
          tipo: state.tipo,
          cal: state.cal ? state.cal : "",
        });

    if (res.sms === "err") {
      toast.error(res.mensaje);
      return;
    }

    toast.success(res.mensaje);

    setTiposTabs({
      ...tiposTabs,
      [state.tipo]: {
        ...tiposTabs[state.tipo],
        pre_detalle_comida_id: res.data.pre_detalle_comida_id,
        isCreate: false,
      },
    });

    setLoading(false);
  };

  const onClickComida = (comida) => {
    const menus =
      comida?.pre_detalle_comida?.filter(
        (item) => item.fecha_menu === fechaValue
      ) || [];

    const auxMenu = menus.reduce((acc, menu) => {
      acc[menu.tipo] = {
        selected: true,
        pre_detalle_comida_id: menu.pre_detalle_comida_id,
        isCreate: false,
        menu: menu.nombre,
        tipo: menu.tipo,
        cal: menu.cal || "",
      };
      return acc;
    }, {});

    setTiposTabs({
      ...tipoTabsInit,
      ...auxMenu,
    });
    setComidaSelected(comida);
  };

  const handleDelete = async (pre_detalle_comida_id, item) => {
    setLoading(true);
    let res = await ApiDeleteComidaDetalle({
      pre_detalle_comida_id,
    });
    if (res.sms === "err") {
      toast.error(res.mensaje);
      return;
    }
    toast.success(res.mensaje);
    setLoading(false);
    setTiposTabs({
      ...tiposTabs,
      [item]: {
        ...tiposTabs[item],
        selected: false,
      },
    });
    init();
  };

  const fechaValue = fecha;

  const fechaToday = dateLocal().split("T")[0];
  const fechaEnLetras =
    fechaToday === fechaValue ? "hoy" : dateToText(fechaValue);

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    if (fechaValue === "") return;
    const menus =
      comidaSelected?.pre_detalle_comida?.filter(
        (item) => item.fecha_menu === fechaValue
      ) || [];

    const auxMenu = menus.reduce((acc, menu) => {
      acc[menu.tipo] = {
        selected: true,
        pre_detalle_comida_id: menu.pre_detalle_comida_id,
        isCreate: false,
        menu: menu.nombre,
        tipo: menu.tipo,
      };
      return acc;
    }, {});

    setTiposTabs({
      ...tipoTabsInit,
      ...auxMenu,
    });
  }, [fechaValue]);

  return (
    <>
      <div>
        <div className="row mt-3 mb-4">
          <div className="col-md-6 col-lg-4  w-100">
            <div
              className=" bg-white  border-0 borde-tarjeta"
              style={{ height: "auto" }}
            >
              <div className="card-body m-0 p-0">
                <div className="w-100 bgfondo2 bordeabajo bordesombreado d-flex flex-column align-items-center d-flex justify-content-center py-3 px-3">
                  <div className="w-100  d-flex justify-content-between align-items-center px-3">
                    <h5 className=" negrita card-title">
                      Menu de {fechaEnLetras}
                    </h5>
                  </div>
                </div>
                <div className="row py-4 ">
                  <div className="col-md-3 ">
                    <div className="d-flex flex-column mx-2">
                      <label className="py-2 negrita">Fecha</label>
                      <input
                        name="fecha"
                        value={fechaValue}
                        disabled={
                          loading || comidaSelected?.pre_comida_id === ""
                        }
                        type="date"
                        onChange={(e) => setFecha(e.target.value)}
                        className="border rounded-2 p-2 "
                      />
                      <label className="py-2 negrita">Comida</label>
                      <div className="row  gap-2">
                        {comidas.map((item, index) => (
                          <ItemComida
                            key={index}
                            comida={item}
                            fechaValue={fechaValue}
                            idSelected={comidaSelected?.pre_comida_id}
                            onClick={() => onClickComida(item)}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-9 ">
                    <div className="row">
                      {comidaSelected !== null && (
                        <>
                          <label className="py-2 text-muted">
                            Seleccione las comidas
                          </label>
                          <div>
                            {Object.keys(TIPO_COMIDA).map((item, index) => (
                              <button
                                key={index}
                                onFocus={(e) => {
                                  e.target.blur();
                                }}
                                style={{
                                  transition: "0.2s",
                                  hover: {
                                    opacity: 0.8,
                                  },
                                }}
                                className={`btn btn-primary mx-1 rounded-2 ${
                                  tiposTabs[item].selected ? "active" : "border"
                                } `}
                                onClick={() => {
                                  if (tiposTabs[item].menu !== "") {
                                    toast.error(
                                      "Ya existe un menu, no puede quitarlo, eliminelo."
                                    );
                                    return;
                                  }
                                  setTiposTabs({
                                    ...tiposTabs,
                                    [item]: {
                                      ...tiposTabs[item],
                                      selected: !tiposTabs[item].selected,
                                    },
                                  });
                                }}
                              >
                                {TIPO_COMIDA_LABEL[item]}
                              </button>
                            ))}
                          </div>
                        </>
                      )}
                    </div>
                    <div className="row">
                      <label className="py-2 negrita">
                        Menu de {fechaEnLetras}
                      </label>
                      {comidaSelected !== null ? (
                        <div className={"col-md-12 px-2 m-0"}>
                          {Object.keys(TIPO_COMIDA).map((item, index) => {
                            if (!tiposTabs[item].selected) return null;
                            return (
                              <div key={index} className="row ">
                                <label className="text-muted p-0 mt-2">
                                  {TIPO_COMIDA_LABEL[item]}{" "}
                                  {tiposTabs[item].isCreate && (
                                    <small className="border border-success text-success px-1 rounded-2">
                                      nuevo
                                    </small>
                                  )}
                                </label>
                                <div className="d-flex justify-content-between align-items-center">
                                  {" "}
                                  <input
                                    type="text"
                                    className=" inputtext2 rounded-2 border p-2 "
                                    name="menu"
                                    style={{ width: "60%" }}
                                    id={item}
                                    value={tiposTabs[item].menu}
                                    onChange={(e) => {
                                      let aux = tiposTabs;
                                      aux[item].menu = e.target.value;
                                      setTiposTabs({ ...aux });
                                    }}
                                    placeholder={`Ingrese la descripción de ${TIPO_COMIDA_LABEL[item]}`}
                                  />
                                  <div className=" d-flex justify-content-start align-items-center">
                                    <input
                                      type="text"
                                      className=" inputtext2 rounded-2 border p-2  mx-2"
                                      name="cal"
                                      style={{ width: "100px" }}
                                      id={item}
                                      value={tiposTabs[item].cal}
                                      onChange={(e) => {
                                        let aux = tiposTabs;
                                        aux[item].cal = e.target.value;
                                        setTiposTabs({ ...aux });
                                      }}
                                      placeholder={`Calorias`}
                                    />
                                    <h4>Cal</h4>
                                  </div>
                                  <button
                                    style={{ width: "10%" }}
                                    className="btn bg-success rounded-2 text-white "
                                    onClick={() => {
                                      handleSubmit({
                                        state: tiposTabs[item],
                                      });
                                    }}
                                  >
                                    {tiposTabs[item].isCreate
                                      ? "Crear"
                                      : "Actualizar"}
                                  </button>
                                  {!tiposTabs[item].isCreate && (
                                    <button
                                      style={{ width: "10%" }}
                                      className="btn bg-danger rounded-2 text-white "
                                      onClick={() =>
                                        handleDelete(
                                          tiposTabs[item].pre_detalle_comida_id,
                                          item
                                        )
                                      }
                                    >
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  )}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <div className="col-md-12">
                          <label className="py-2 negrita text-danger">
                            Seleccione una comida
                          </label>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MenuComida;
